import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonHeader, IonToolbar, IonTitle } from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InnerHeader',
  props: ["title", "subtitle"],
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonHeader), { collapse: "condense" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), { color: "primary" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonTitle), {
            size: "large",
            class: "ion-justify-content-center",
            color: "white"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title), 1)
            ]),
            _: 1
          }),
          (props.subtitle)
            ? (_openBlock(), _createBlock(_unref(IonTitle), {
                key: 0,
                size: "small",
                class: "ion-justify-content-center",
                color: "white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.subtitle), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})